import { render, staticRenderFns } from "./Wins.vue?vue&type=template&id=3ccead2e"
import script from "./Wins.vue?vue&type=script&lang=js"
export * from "./Wins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports